export default __webpack_public_path__ + "static/media/80.44af67a3.png";